<template>
  <section>
    <template v-if="dataList.length">
      <div class="guess-box">
        <template v-for="(item, index) in dataList">
          <div :key="index" class="guess-box__item">
            <nuxt-link :to="{ name: 'pdp', params: { code: item.productNo } }">
              <GtImage
                class="swiper-j_image"
                :src="getUrlWithOss(item.imgUrl, {})"
                aspect-ratio="121.75%"
                :alt="item.productName"
              />
            </nuxt-link>

            <div class="guess-box__item-info">
              <p>{{ item.productName }}</p>
              <span>￥{{ item.productPrice }}</span>
            </div>
          </div>
        </template>
      </div>
    </template>
  </section>
</template>

<script>
import { GtImage } from '@speedshop/template';
import ossImage from '@/mixins/ossImage';
export default {
  name: 'GuessMobileSwiper',
  components: { GtImage },
  mixins: [ossImage],
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    event: {
      type: String
    }
  },

  data() {
    return {};
  },
  watch: {
    dataList: {
      handler(val) {
        if (val.length) {
          val.forEach(item => {
            if (!this.isMobile) {
              item.imgUrl =
                item.mediaLink && item.mediaLink.replace(/,http/g, '[http').split('[')[0];
            } else {
              item.imgUrl =
                (item.mobileMediaLink &&
                  item.mobileMediaLink.replace(/,http/g, '[http').split('[')[0]) ||
                (item.mediaLink && item.mediaLink.replace(/,http/g, '[http').split('[')[0]);
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.guess-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 48px;
  &__item {
    width: calc((100% - 24px) / 3);
    &-info {
      text-align: left;
      line-height: 18px;
      p {
        margin: 4px 0;
        color: var(--main-color-ua-dark-grey, #14141e);
        font-size: 12px;
        font-weight: 400;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}
</style>
